import React from "react";
import { Link } from "react-router-dom";
import { Icon20, Icon21, logobpom} from "../imagepath";

const Footer = () => {
  return (
    <footer className="footer">
      {/* Footer Top */}
      <div className="footer-top">
        <div className="container">
          <div className="row">
            <div className="col-lg-4 col-md-6">
              {/* Footer Widget */}
              <div className="footer-widget footer-about">
                <div className="footer-logo">
                  <img src={logobpom} alt="logo" />
                </div>
                <div className="footer-about-content">
                  <p>
                    SIMPUL (Sistem Informasi Parameter Uji Laboratorium)
                  </p>
                  <p>
                  
                   
                    
                  </p>
                  <div className="footer-contact-info">
                  <p className="mb-0"><br />
                    <span><i className="fa fa-download" aria-hidden="true"></i></span> 
                    <Link target="_blank" to="https://drive.google.com/file/d/1ABUJmmDbl-Nw_QW2gluTVoZMdRXPoRnp/view?usp=sharing">  PNBP-PP32 Tahun 2017</Link>
                  </p><br />
                  <div className="footer-address ">
                    <img src={Icon20} alt="" className="img-fluid" />
                    <p>
                      {" "}
                      Jln. Baji Minasa No. 2, Makasar, Sulawesi Selatan - 90126 Makassar, Sulawesi Selatan{" "}
                    </p>
                  </div>
                  <p className="mb-0">
                    <img src={Icon21} alt="" className="img-fluid" />
                    (0411) 879043
                  </p>
                  <p className="mb-0"><br />
                    <img src={Icon21} alt="" className="img-fluid" />
                   Pelaporan Gratifikasi : 0812-7788-5655
                  </p>
                  <p className="mb-0"><br />
                    <span><i className="fa fa-envelope" aria-hidden="true"></i></span> 
                    bpom_makasar@pom.go.id/
                  </p>
                  <p className="mb-0"><br />
                    <span><i className="fa fa-envelope" aria-hidden="true"></i></span> 
                    bbpomdimakassar@gmail.com/
                  </p>
               
                 
                </div>
                </div>
              </div>
              {/* /Footer Widget */}
            </div>
            <div className="col-lg-2 col-md-6">
              {/* Footer Widget */}
              <div className="footer-widget footer-menu">
                <h2 className="footer-title">Laboratorium Pengujian SUL-SEL</h2>
                <ul>
                  <li>
                    <Link target="_blank" to="https://www.kkp.go.id/unit-kerja/bkipm/publikasi/infografis-detail/alur-penyediaan-jasa-pengujian-hpi-dan-mutu65f9461734775.html">Laboratorium BBKIPM</Link>
                  </li>
                  <li>
                    <Link target="_blank" to="https://bbihpmm.kemenperin.go.id/layanan-jasa/pengujian">Laboratorium BBIHPMM</Link>
                  </li>
                  <li>
                    <Link target="_blank" to="https://bbvetmaros.ditjenpkh.pertanian.go.id/">Laboratorium BBVETMAROS</Link>
                  </li>
                </ul>
              </div>
              {/* /Footer Widget */}
            </div>
            <div className="col-lg-2 col-md-6">
              {/* Footer Widget */}
              <div className="footer-widget footer-menu">
                <h2 className="footer-title">Aplikasi Publik BPOM</h2>
                <ul>
                  <li>
                    <Link to="https://www.pom.go.id/">Website BPOM </Link>
                  </li>
                  <li>
                    <Link to="https://sipt.pom.go.id/pihak-3/login">Portal SIPT Pihak Ketiga</Link>
                  </li>
                  <li>
                    <Link to="https://new-aero.pom.go.id/">Registrasi Obat</Link>
                  </li>
                  <li>
                    <Link to="https://asrot.pom.go.id/asrot/">Reg. Obat Trad. dan Suplemen Kes</Link>
                  </li>
                  <li>
                    <Link to="https://notifkos.pom.go.id/"> Notifikasi Kosmetik</Link>
                  </li>
                  <li>
                    <Link to="https://ereg-rba.pom.go.id/"> Registrasi Pangan Olahan</Link>
                  </li>
                </ul>
              </div>
              {/* /Footer Widget */}
            </div>
            <div className="col-lg-4 col-md-6">
              {/* Footer Widget */}
              <div className="footer-widget footer-contact">
                <h2 className="footer-title">Lokasi</h2>
                <div className="news-letter">
                  <iframe title="Peta lokasi Unit Layanan Pengaduan Konsumen BBPOM Makassar" src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d15894.444424512547!2d119.411501!3d-5.1660949!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x7af2b84f5d2c33b3!2sUnit%20Layanan%20Pengaduan%20Konsumen%20Badan%20POM!5e0!3m2!1sid!2sid!4v1662433798494!5m2!1sid!2sid" style={{width:'300px', border:'0', height:300}} allowFullScreen="" loading="lazy" referrerPolicy="no-referrer-when-downgrade"></iframe>
                        
                </div>
               
              </div>
              {/* /Footer Widget */}
            </div>
          </div>
        </div>
      </div>
      {/* /Footer Top */}
      {/* Footer Bottom */}
      <div className="footer-bottom">
        <div className="container">
          {/* Copyright */}
          <div className="copyright">
            <div className="row">
              <div className="col-md-6">
                <div className="privacy-policy">
                  <ul>
                    <li>
                      <Link to="#">Terms</Link>
                    </li>
                    <li>
                      <Link to="">Privacy</Link>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="col-md-6">
                <div className="copyright-text">
                  <p className="mb-0">©TIM IT BBPOM Di Makassar 2024.</p>
                </div>
              </div>
            </div>
          </div>
          {/* /Copyright */}
        </div>
      </div>
      {/* /Footer Bottom */}
    </footer>
  );
};

export default Footer;
